import { GitCompare } from "lucide-react";
import { setCompareMode, getCompare } from "../lib/compare";
import { useCompareMode } from "../lib/useCompareMode";
import { CompareHelp } from "./CompareHelp";

// T71: listing-level Compare mode toggle (+ "What is compare?") at the top of listings with 2+ products. Never on the homepage.
export function CompareModeButton({ prefix }) {
  const on = useCompareMode();
  const n = on ? getCompare().length : 0;
  return (
    <div className="flex items-center gap-1" data-testid={`${prefix}-compare-mode`}>
      <button type="button" aria-pressed={on} onClick={() => setCompareMode(!on)} data-testid={`${prefix}-compare-toggle`}
        title={on && n ? "Compare stays on while items are in your compare list" : undefined}
        className={`inline-flex min-h-[44px] items-center gap-2 rounded-full border px-4 text-sm font-bold transition-colors ${on ? "border-[var(--brand-primary)] bg-[var(--brand-primary)] text-white" : "border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary-tint)]"}`}>
        <GitCompare size={15} aria-hidden="true" /><span>{on ? (n ? `Comparing (${n})` : "Compare on") : "Compare"}</span>
      </button>
      <CompareHelp testid={`${prefix}-compare-help`} />
    </div>
  );
}
